import type { TFunction } from "i18next";
import { getBlockDefinition } from "./blocks/registry";
import { findRow } from "./find";
import type { Block, EmailDocument } from "./types";

export function rowLabel(): string {
  return 'Row';
}

export function rowLayoutLabel(): string {
  return 'Row layout';
}

export function groupLabel(): string {
  return 'Row group';
}

export function columnLabel(): string {
  return 'Column';
}

export function columnNumberLabel(
  document: EmailDocument,
  rowId: string,
  columnId: string,
): string {
  const row = findRow(document, rowId);
  if (!row) {
    return columnLabel();
  }

  const index = row.columns.findIndex(column => column.id === columnId);
  return index >= 0 ? `${columnLabel()} ${index + 1}` : columnLabel();
}

export function buttonRowSlotLabel(index: number): string {
  return `Button ${index + 1}`;
}

export function blockLabel(block: Block): string {
  return getBlockDefinition(block.type).label;
}

export function translateRowLabel(t: TFunction): string {
  return t("Row");
}

export function translateGroupLabel(t: TFunction): string {
  return t("Row group");
}

export function translateColumnLabel(t: TFunction): string {
  return t("Column");
}

export function translateColumnNumberLabel(
  t: TFunction,
  document: EmailDocument,
  rowId: string,
  columnId: string,
): string {
  const row = findRow(document, rowId);
  if (!row) {
    return translateColumnLabel(t);
  }

  const index = row.columns.findIndex(column => column.id === columnId);
  return index >= 0
    ? t("Column {{number}}", { number: index + 1 })
    : translateColumnLabel(t);
}

export function translateButtonRowSlotLabel(
  t: TFunction,
  index: number,
): string {
  return t("Button {{number}}", { number: index + 1 });
}

export function translateBlockLabel(t: TFunction, block: Block): string {
  return t(getBlockDefinition(block.type).label);
}

export function translateColumnOverflowHintMessage(t: TFunction): string {
  return t(
    "This button is wider than its column. Shorten the text or use fewer columns.",
  );
}

export function translateRowColumnOverflowHintMessage(t: TFunction): string {
  return t(
    "Some buttons don't fit in their columns. Shorten the button text or use fewer columns.",
  );
}
